export type Device = 'desktop' | 'notebook' | 'tablet' | 'mobile' | 'printer';
